export const FULL_CARD_SIZES = ['large', 'extra-large'];